import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_1M_38_95_1W_6_93',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1m_38_95_1w_6_93_usd',
			ARS: 'simple_premium_1m_44900_1w_7900_ars',
			AUD: 'simple_premium_1m_59_99_1w_10_99_aud',
			BRL: 'simple_premium_1m_219_1w_38_99_brl',
			CAD: 'simple_premium_1m_49_99_1w_9_99_cad',
			CLP: 'simple_premium_1m_36900_1w_6900_clp',
			COP: 'simple_premium_1m_161900_1w_28900_cop',
			DKK: 'simple_premium_1m_259_1w_39_99_dkk',
			EUR: 'simple_premium_1m_38_95_1w_6_93_eur',
			GBP: 'simple_premium_1m_38_95_1w_6_93_gbp',
			MXN: 'simple_premium_1m_749_1w_129_99_mxn',
			NOK: 'simple_premium_1m_389_1w_69_99_nok',
			PLN: 'simple_premium_1m_139_99_1w_25_99_pln',
			SEK: 'simple_premium_1m_369_1w_65_99_sek',
			TRY: 'simple_premium_1m_1519_1w_269_try',
		},
		primer: 'prd_2rG6ISTI3cVz',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 6.93,
			ARS: 7900,
			AUD: 10.99,
			BRL: 38.99,
			CAD: 9.99,
			CLP: 6900,
			COP: 28900,
			DKK: 39.99,
			EUR: 6.93,
			GBP: 6.93,
			MXN: 129.99,
			NOK: 69.99,
			PLN: 25.99,
			SEK: 65.99,
			TRY: 269,
		},
		originalPriceMap: {
			USD: 17.77,
			ARS: 20256,
			AUD: 28.18,
			BRL: 99.97,
			CAD: 25.62,
			CLP: 17692,
			COP: 74102,
			DKK: 102.53,
			EUR: 17.77,
			GBP: 17.77,
			MXN: 333.31,
			NOK: 179.46,
			PLN: 66.64,
			SEK: 169.2,
			TRY: 689.74,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 38.95,
			ARS: 44900,
			AUD: 59.99,
			BRL: 219,
			CAD: 49.99,
			CLP: 36900,
			COP: 161900,
			DKK: 259,
			EUR: 38.95,
			GBP: 38.95,
			MXN: 749,
			NOK: 389,
			PLN: 139.99,
			SEK: 369,
			TRY: 1519,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('female_yoga.pages.paywall.plans.1_week.into_period_text'), // '7-days'
		explicitTermsIntervalText: $t('female_yoga.pages.paywall.plans.1_week.period_text'), // 'month'
		billingSubtitlePeriodText: $t('female_yoga.pages.paywall.plans.1_week.billing_period_text'), // 'first week'
		footerPeriodText: $t('female_yoga.pages.paywall.plans.1_week.footer_period_text'), // '1-week'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.7_days.sub_period_text'), // 'monthly',
		updatedTermsPeriodText: $t('female_yoga.pages.paywall.plans.1_week.terms_period_text'), // 'first week'
	}),
}
